module.exports = __webpack_public_path__ + "static/img/Rejuvenation-4.0851da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/Rejuvenation-4.png
// module id = UP/i
// module chunks = 1